import { styled } from "sharedUI/styles";

export const AppPlanPanelContainer = styled.div`
    display: flex;
    flex-direction: column;

    .group {
        margin: 10px 0px;
    }

    .learn-more {
        text-decoration: underline !important;
        color: ${p => p.theme.fgColorMedium} !important;
        font-size: 13px;
        font-weight: 300;

        :hover {
            color: ${p => p.theme.fgColorMedium} !important;
        }
    }

    .cancel {
        > button {
            color: ${p => p.theme.destroyColor};
        }
    }

    .bold-title {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 2px;
    }

    .label {
        font-size: 12px;
    }

    > .summary {
        display: flex;
        flex-direction: column;
        padding: 16px;
        background-color: ${p => p.theme.bgColorAlt};
        border-radius: 3px;

        > .cost-section {
            display: flex;
            align-items: center;

            > .number {
                font-size: 28px;
                font-weight: 700;
                margin-right: 8px;
            }

            > .description {
                width: auto;
                font-size: 11px;
            }
        }
    }

    > .submit {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 10px;
    }

    > .private-users {
        .info {
            margin: 8px 0px;
        }
    }
`;
